import * as React from 'react';
import { useMedia } from 'react-use';
import { Tag } from 'antd';
import API_SERVICE from './api-service';
import Parameters from 'shared/parameters';

export const useLayoutMedia = (layoutsToVerify: string[]) => {
    let layoutMode: 'Mobile' | 'TabletPortrait' | 'TabletLandscape' | 'Desktop' = 'Desktop';
    if (useMedia('(max-width: 1024px)')) {
        layoutMode = 'TabletLandscape';
    }
    if (useMedia('(max-width: 768px)')) {
        layoutMode = 'TabletPortrait';
    }
    if (useMedia('(max-width: 576px)')) {
        layoutMode = 'Mobile';
    }
    return layoutsToVerify.indexOf(layoutMode) > -1;
};
export const CurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
export const GetOrderTag = (name: string) => {
    switch (name) {
        case 'Complete':
            return <Tag color={'success'}>{name}</Tag>;
        case 'Pending':
            return <Tag color={'warning'}>{name}</Tag>;
        default:
            return <Tag>{name}</Tag>;
    }
};


export const getImageUrl = (data: any) => {
    if (!data) {
        return '';
    }
    return `${Parameters.ImageBaseUrl}` + data.slug + data.ext;
};
export const getAttachmentsUrl = (data: any) => {
    if (!data) {
        return '';
    }
    return `${Parameters.BaseUrl}` + '/storage/uploads/' + data.slug + data.ext;
};
export const UploadImage = async (file: any) => {
    const data = new FormData();
    data.append('files[0]', file);
    const reader = new FileReader();
    let image = null;
    let imageId = null;
    reader.onload = function(e) {
        // @ts-ignore
        image = e.target.result;
    };
    reader.readAsDataURL(file); // convert to base64 string
    try {
        const { data: { data: { items } } } = await API_SERVICE.mediaUpload(data);
        imageId = items[0];
    } catch (e) {
        return { image: null, imageId: null, error: API_SERVICE.handleErrors(e) };
    }
    return { image, imageId, error: null };
};
export const UploadFile = async (file: any) => {
    const data = new FormData();
    data.append('files[0]', file);
    let fileId = null;
    try {
        const { data: { data: { items } } } = await API_SERVICE.mediaUpload(data);
        fileId = items[0];
    } catch (e) {
        return { image: null, imageId: null, error: API_SERVICE.handleErrors(e) };
    }
    return { file, fileId, error: null };
};

export const filteredList = (searchKey: string, items: any[]) => {
    if (!searchKey) {
        return items;
    }
    return items.filter((c: any) => {
        let passed = false;
        for (const key in c) {
            const value = c[key];
            if (value && typeof value === 'string' && value.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) {
                passed = true;
            }
        }
        return passed;
    });
};

function parseDotNotation(str: string, val: any, obj: any) {
    let currentObj = obj,
        keys = str.split('.'),
        i, l = Math.max(1, keys.length - 1),
        key;

    for (i = 0; i < l; ++i) {
        key = keys[i];
        currentObj[key] = currentObj[key] || {};
        currentObj = currentObj[key];
    }

    currentObj[keys[i]] = val;
    delete obj[str];
}

export function dotToObject(obj: any) {
    for (let key in obj) {
        if (key.indexOf('.') !== -1) {
            parseDotNotation(key, obj[key], obj);
        }
    }
    return obj;
}

export function objectToDot(obj: any) {
    let res: any = {};
    (function recurse(obj, current) {
        for (let key in obj) {
            let value = obj[key];
            let newKey = (current ? current + '.' + key : key);
            if (value && typeof value === 'object') {
                // @ts-ignore
                recurse(value, newKey);
            } else {
                res[newKey] = value;
            }
        }
    })(obj);
    return res;
}
